import React, { useState, useRef } from "react";
import Slider from "react-slick";
import Lightbox from "react-image-lightbox";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-image-lightbox/style.css";

const GalleryCarousel = ({ images }) => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const sliderRef = useRef(null);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
  };

  return (
    <div className="content">
      <h1>Photo Gallery</h1>
    <div className="gallery-carousel">
      {/* Main Carousel */}
      <Slider ref={sliderRef} {...settings}>
        {images.map((img, index) => (
          <div
            key={index}
            className="gallery-slide"
            onClick={() => {
              setPhotoIndex(index);
              setLightboxOpen(true);
            }}
          >
            <img src={img} alt={`Slide ${index + 1}`} />
          </div>
        ))}
      </Slider>

      {/* Thumbnails */}
      <div className="thumbnail-row">
        {images.map((img, index) => (
          <div
            key={index}
            className="thumbnail"
            onClick={() => {
              if (sliderRef.current && typeof sliderRef.current.slickGoTo === 'function') {
                sliderRef.current.slickGoTo(index);
              }
              setPhotoIndex(index);
            }}
          >
            <img src={img} alt={`Thumbnail ${index + 1}`} />
          </div>
        ))}
      </div>

      {/* Lightbox */}
      {lightboxOpen && (
        <Lightbox
          mainSrc={images[photoIndex]}
          nextSrc={images[(photoIndex + 1) % images.length]}
          prevSrc={images[(photoIndex + images.length - 1) % images.length]}
          onCloseRequest={() => setLightboxOpen(false)}
          onMovePrevRequest={() =>
            setPhotoIndex((photoIndex + images.length - 1) % images.length)
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % images.length)
          }
        />
      )}
    </div></div>
  );
};

export default GalleryCarousel;
